// extracted by mini-css-extract-plugin
export default {"contents":"ME-z","sectionHeading":"NE-z"};